import React from 'react'
import { Link } from 'react-router-dom'

function AboutPageHero() {
    return (
        <section className="about-page-intro rts-section-gap">
            <div className="container">
                <div className="row align-items-center g-4 g-xl-5">
                    <div className="col-lg-6 order-2 order-lg-1">
                        <div className="about-page-intro__content">
                            <p className="about-page-intro__label">TechDigit Solutions</p>
                            <h2 className="about-page-intro__headline">
                                Built by People Who Got Tired of Watching It{' '}
                                <span className="about-page-intro__accent">Done Wrong</span>
                            </h2>
                            <p className="about-page-intro__disc">
                                TechDigit Solutions exists because four healthcare IT professionals decided that doing it
                                right was worth more than doing it fast.
                            </p>
                            <div className="about-page-intro__cta">
                                <Link to="/contactus" className="rts-btn btn-primary deactive">
                                    Schedule Your Free Consultation
                                </Link>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-6 order-1 order-lg-2">
                        <div className="about-page-intro__media">
                            <img
                                src="assets/images/about/about.jpg"
                                alt=""
                                className="about-page-intro__img"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default AboutPageHero
